// NODE_TYPES — структурные типы узлов, не меняются, хранятся статически
export const NODE_TYPES = [
  { value: 'start', label: 'Старт' },
  { value: 'end',   label: 'Конец' },
  { value: 'task',  label: 'Задача' },
  { value: 'auto',  label: 'Авто-действие' },
  { value: 'event', label: 'Событие' },
]

// Подсказки для полей EditPanel — статичные тексты для разработчиков
export const FIELD_HINTS = {
  node_label: {
    title: 'Название узла',
    text: 'Текст, который отображается на схеме внутри узла.',
    example: 'Пример: «Подписать АСР (подрядчик)»',
  },
  node_type: {
    title: 'Тип узла',
    text: 'Определяет роль узла:\n• start — начало\n• task — задача сотруднику\n• auto — автодействие без участия человека\n• end — завершение',
    example: 'Пример: узел «Вызов ИТР» — тип auto (MASTER_ADD)',
  },
  assign_type_code: {
    title: 'Роль исполнителя',
    text: 'Кому создаётся задача. Движок ищет сотрудника с этой ролью в проекте.',
    example: 'Пример: CONTRACTOR — подрядчик должен подписать документ',
  },
  task_type_code: {
    title: 'Тип задачи',
    text: 'Конкретное действие. Соответствует записи в task_type_tab. Новые типы добавляются через таблицу.',
    example: 'Пример: sign_asr — задача «Подписать акт скрытых работ»',
  },
  auto_action_code: {
    title: 'Авто-действие',
    text: 'Код автоматического действия. Новые авто-действия добавляются в bpmn_auto_action_tab и в функцию bpmn_process__handle_event.',
    example: 'Пример: MASTER_ADD — автоматически создаёт вызов ИТР',
  },
  join_type: {
    title: 'Тип слияния (Join)',
    text: 'Определяет как узел реагирует на несколько входящих веток.\n• OR (по умолчанию) — активируется от любой одной входящей ветки.\n• AND — ждёт, пока ВСЕ входящие ветки завершатся, и только потом активируется.',
    example: 'Пример: три параллельных подписанта (ПСД, ТехКонтроль, ПТО) → узел «Завершение» с join_type=AND активируется только после того, как все трое подписали.',
  },
  node_code: {
    title: 'Код узла',
    text: 'Уникальный идентификатор узла внутри схемы.',
    example: 'Пример: s1_task_sign_asr_c (схема 1, задача, подписать asr, contractor)',
  },
  trigger_event: {
    title: 'Событие-триггер',
    text: 'Бизнес-событие, которое активирует переход. Новые события добавляются в bpmn_trigger_event_tab и вызываются через bpmn_process__handle_event в нужной функции БД.',
    example: 'Пример: DOC_SIGNED — подписан документ',
  },
  trigger_doc_type_code: {
    title: 'Тип документа',
    text: 'Фильтр по типу документа. Значения из floor_map_document_type_tab.',
    example: 'Пример: ASR_PRE_CALL — только для АСР',
  },
  trigger_assign_type_code: {
    title: 'Тип подписанта',
    text: 'Фильтр по роли того, кто совершил действие. Значения из assign_type_tab.',
    example: 'Пример: SECTION_FOREMAN — только если подписал Прораб',
  },
  trigger_task_type_code: {
    title: 'Тип задачи (для TASK_COMPLETED)',
    text: 'Используется только с TASK_COMPLETED. Реагирует на завершение конкретной задачи.',
    example: 'Пример: upload_certificate — загрузил сертификат',
  },
  source_node_id: {
    title: 'Узел-источник',
    text: 'Откуда начинается ребро — текущее состояние процесса.',
    example: 'Пример: «Подписать АСР» → ребро ведёт к «Вызов ИТР»',
  },
  target_node_id: {
    title: 'Узел-цель',
    text: 'Куда переходит процесс после выполнения ребра.',
    example: 'Пример: «Вызов ИТР» → выполнится MASTER_ADD',
  },
  edge_label: {
    title: 'Подпись ребра',
    text: 'Короткое описание рядом со стрелкой. Только для визуализации.',
    example: 'Пример: «АСР подписан → Мастер»',
  },
}

// Хелперы для TaskNode.vue и других компонентов — используют стор если он доступен,
// иначе возвращают сам код (fallback для SSR/первого рендера)
import { useBpmnDicts } from './useBpmnDicts'

export function getRoleLabel(code) {
  try { return useBpmnDicts().getRoleLabel(code) } catch { return code || '—' }
}
export function getTaskLabel(code) {
  try { return useBpmnDicts().getTaskLabel(code) } catch { return code || '—' }
}
export function getEventLabel(code) {
  try { return useBpmnDicts().getEventLabel(code) } catch { return code || '—' }
}
export function getDocLabel(code) {
  try { return useBpmnDicts().getDocLabel(code) } catch { return code || '—' }
}
export function getNodeTypeLabel(code) {
  return NODE_TYPES.find((n) => n.value === code)?.label || code || '—'
}
